import { withRouter, Link } from "react-router-dom";

import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { Card, Divider, Slide, Typography, Box, Tabs, Tab, Avatar } from '@material-ui/core';
import CartPedidos from '../../components/CartPedidos';
import { getFilialUser } from "../../services/auth";
import { FiUser, FiTruck, FiClipboard, FiPrinter, FiPackage, FiClock, FiCheckCircle, FiSend, FiArchive, FiBox, FiCornerDownRight } from 'react-icons/fi';
import { Grid, Stack } from '@material-ui/core';
import { useHistory } from "react-router-dom";
import moment from 'moment';


//actions
import editStatusOrder from "../../actions/pedidos/editar-status-pedido";
import editHoldOrder from "../../actions/pedidos/editar-hold-pedido";
import emitirEtiqueta from "../../actions/emitirEtiqueta";
import getListaPedidosByStatus from "../../actions/relatorios/lista-pedidos-by-status";
import getListaPedidosByStatus2 from "../../actions/relatorios/lista-pedidos-by-status-2";
import getListaPedidosSeparados from "../../actions/relatorios/lista-pedidos-separados";
import getListaPedidosAprovados from "../../actions/relatorios/lista-pedidos-aprovados";
// import getOrder from "../../actions/getOrder";
import buscarFilialPorCodigoFilial from "../../actions/cadastro/buscar-filial-por-codigo-filial";

import { CardPedidosPendentes } from '../../components/Pedidos/CardPedidosPendentes';
import { CardPedidosAceitos } from '../../components/Pedidos/CardPedidosAceitos';
import { CardPedidosDespachados } from '../../components/Pedidos/CardPedidosDespachados';
import { CardPedidosAprovados } from '../../components/Pedidos/CardPedidosAprovados';
import { CardPedidosExpedicao } from '../../components/Pedidos/CardPedidosExpedicao';
import { CardPedidosBackoffice } from '../../components/Pedidos/CardPedidosBackoffice';


const cardSx = {
  p: { xs: 2.5, md: 3 },
  borderRadius: 2.5,
  border: '1px solid',
  borderColor: 'grey.200',
  boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
  bgcolor: '#fff',
};

const sectionHeaderSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
  pb: 1.5,
  borderBottom: '1px solid',
  borderColor: 'grey.200',
};

const labelSx = {
  fontSize: 10,
  color: '#999',
};

const valueXlSx = {
  fontSize: 14,
  fontWeight: 700,
  color: '#333',
};

const valueMdSx = {
  fontSize: 10,
  fontWeight: 600,
  color: '#333',
};

const columnHeaderSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  p: 1.5,
  borderRadius: '10px 10px 0 0',
  bgcolor: '#1a1a2e',
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


function PedidosPage(props) {

  const history = useHistory();
  const [detalhesPedido, setDetalhesPedido] = useState('')
  const [listaPedidos1, setListaPedidos1] = useState([])
  const [listaPedidos2, setListaPedidos2] = useState([])
  const [listaPedidos3, setListaPedidos3] = useState([])
  const [listaPedidos4, setListaPedidos4] = useState([])
  const [listaPedidos5, setListaPedidos5] = useState([])
  const [listaPedidos6, setListaPedidos6] = useState([])
  const [listaPedidos7, setListaPedidos7] = useState([])

  const [open, setOpen] = React.useState(false);
  const [dadosFilial, setDadosFilial] = React.useState('');

  const { moovpay } = detalhesPedido || {};

  const moopayResponse = moovpay?.payment?.RetornoStatusCodigo === "00" && moovpay?.payment?.RetornoStatusCompra.length > 0
    ? moovpay?.payment?.RetornoStatusCompra[0]
    : null;


  function validaParcelasPedido(valueDadosParcelas, valueParcelasZoop, gateway) {
    let parcelas =  1;
    if(gateway === "pagarme") {
      parcelas = valueParcelasZoop?.installment_plan;
    } else {
      parcelas = valueParcelasZoop?.installment_plan?.number_installments || "1";
    }

   return parcelas;

  }



  function validaStatus(string) {
    if (string === "60774fa684e6861cb41a472f") {
      return "Pendente Pagamento";
    } else if (string === "6143439585ee0369a5dfacbc") {
      return "Cancelado";
    } else if (string === "60774f9c84e6861cb41a472e") {
      return "Pedido Feito";
    } else if (string === "6143412285ee0369a5dfacb4") {
      return "Aceito";
    } else if (string === "60774fb684e6861cb41a4730") {
      return "Pag. Aprovado";
    } else if (string === "6143414c85ee0369a5dfacb5") {
      return "Expedição";
    } else if(string === "resEditarCliente") {
     return "Backoffice";
    }
  }

  function validaEntrega(string) {
    if (string === "61532d990d253dd8a450bcde") {
      return "Correios - Pac";
    } else if (string === "615602fdeaf72f4fe7f5ee24") {
      return "Correios - Sedex";
    } else if (string === "61560313eaf72f4fe7f5ee25") {
      return "Patrus";
    } else if (string === "6156031beaf72f4fe7f5ee26") {
      return "Retirada em Loja";
    } else if (string === "61560325eaf72f4fe7f5ee27") {
      return "Entrega Katuxa";
    }

  }

  function validaTipoPagamento(string) {
    if (string === "credit") {
      return "Cartão Crédito";
    } else if (string === "debit") {
      return "Cartão Débito";
    } else if (string === "boleto") {
      return "Boleto Bancário";
    } else if (string === "pix") {
      return "Pix";
    }

  }

  const validaIsDivinopolis = item => {
    if(valida(item) === true) {
      editStatusOrderFunction({ statusId: "6143436085ee0369a5dfacbb", item, isHold: true })
    } else {
      editStatusOrderFunction({ statusId: "630d0625d8c7d3d0ea112058", item, isHold: true })
    }
  }

    function valida(item) {
      const value = Number(item.shipping_address.postal_code);
        if(value >= 35500000 & value <= 35505000){
          return true;
        } else {
          return false;
        }
    }

  const editStatusOrderFunction = ({ statusId, item, isHold }) => {
    editStatusOrder({ status_id: statusId, number: item.number, isHold: isHold }).then(res => {
      carregaLista();
    })
  };

  const editStatusHoldFunction = ({ item, isHold }) => {
    editHoldOrder({ number: item.number, isHold: isHold }).then(res => {
      carregaLista();
    })
  }

  const Lista1 = ({ List1, onAction }) => (
    <Stack direction="column" spacing={1}>

      {List1.map(item => (
        <CardPedidosPendentes
          key={item._id}
          item={item}
          onAction={() => editStatusHoldFunction({ item, isHold: true })}
          click={() => verPedido(item)}
        />
      ))}
    </Stack>
  );

  const Lista2 = ({ List2, onDespacharPedido, onPrintPedido }) => (
    <Stack direction="column" spacing={1}>
      {List2.map(item => (
        <CardPedidosAceitos
          key={item._id}
          item={item}
          onDespacharPedido={onDespacharPedido}
          click={() => verPedido(item)}
        />
      ))}
    </Stack>
  );

  const Lista3 = ({ PedidosDespachados, onFinalizarPedido }) => (
    <Stack direction="column" spacing={1}>
      {PedidosDespachados.map(item => (
        <CardPedidosAprovados
          key={item._id}
          item={item}
          onAction={() => {
            editStatusOrderFunction({ statusId: "6143414c85ee0369a5dfacb5", item, isHold: true })
          }}
          click={() => verPedido(item)}
        />
      ))}
    </Stack>
  );

  const Lista4 = ({ PedidosDespachados, onFinalizarPedido, onAction }) => (
    <Stack direction="column" spacing={1}>
      {PedidosDespachados.map(item => (
        <CardPedidosExpedicao
          key={item._id}
          item={item}
          onAction={() => editStatusOrderFunction({ statusId: "6143434b85ee0369a5dfacba", item, isHold: true })}
          click={() => verPedido(item)}
        />
      ))}
    </Stack>
  );



  const Lista5 = ({ PedidosDespachados, onFinalizarPedido }) => (
    <Stack direction="column" spacing={1}>
      {PedidosDespachados.map(item => (
        <CardPedidosDespachados
          key={item._id}
          item={item}
          onAction={() => validaIsDivinopolis(item)}
          click={() => verPedido(item)}
        />
      ))}
    </Stack>
  );

  const Lista6 = ({ PedidosDespachados, onFinalizarPedido }) => (
    <Stack direction="column" spacing={1}>
      {PedidosDespachados.map(item => (
        <CardPedidosBackoffice
          key={item._id}
          item={item}
          titleButton="Colocar em Trânsito"
          onAction={() => editStatusOrderFunction({ statusId: "6143432885ee0369a5dfacb9", item, isHold: true })}
          click={() => verPedido(item)}
        />
      ))}
    </Stack>
  );

  const Lista7 = ({ PedidosDespachados, onFinalizarPedido }) => (
    <Stack direction="column" spacing={1}>
      {PedidosDespachados.map(item => (
        <CardPedidosBackoffice
          key={item._id}
          item={item}
          onAction={() => editStatusOrderFunction({ statusId: "6143436085ee0369a5dfacbb", item, isHold: true })}
          click={() => verPedido(item)}
          titleButton="Finalizar"
        />
      ))}
    </Stack>
  );



  const verPedido = (item) => {
    setOpen(true);
    setDetalhesPedido(item);
    buscarFilialPorCodigoFilial(item.dadosOrigemPedido.filial).then(res => {
      let data = {
        filial: res.data.codigo_filial,
        cep: res.data.cep,
        rua: res.data.logradouro,
        bairro: res.data.bairro,
        cidade: res.data.localidade,
        estado: res.data.uf
      }
      setDadosFilial(res.data);
    });
    console.log(item)

  };

  const handleClose = () => {
    setOpen(false);
    setDetalhesPedido('')
  };

  async function getDataFilial(string) {
    try {
     const res = await buscarFilialPorCodigoFilial(string);
      return res;
    } catch (error) {
      console.log('error getDataFilial', error);
    }
  }



  const handleEmitirEtiqueta = async () => {

    const dataFilialFaturamento = await getDataFilial(detalhesPedido.items[0].filial);
    const dataFilialOrigemPedido = await getDataFilial(detalhesPedido.dadosOrigemPedido.filial);

    let scopeFilialFaturamento = {
      logradouro: dataFilialFaturamento.data.logradouro.normalize('NFD').replace(/[\u0300-\u036f]/g, ""),
      numero: dataFilialFaturamento.data.numero.normalize('NFD').replace(/[\u0300-\u036f]/g, ""),
      bairro: dataFilialFaturamento.data.bairro.normalize('NFD').replace(/[\u0300-\u036f]/g, ""),
      localidade: dataFilialFaturamento.data.localidade.normalize('NFD').replace(/[\u0300-\u036f]/g, ""),
      complemento: dataFilialFaturamento.data.complemento.normalize('NFD').replace(/[\u0300-\u036f]/g, ""),
      uf: dataFilialFaturamento.data.uf,
      cep: dataFilialFaturamento.data.cep
    }

    let scopeFilialOrigemPedido = {
      nome_completo: detalhesPedido.shipping_address.full_name.normalize('NFD').replace(/[\u0300-\u036f]/g, ""),
      logradouro: dataFilialOrigemPedido.data.logradouro.normalize('NFD').replace(/[\u0300-\u036f]/g, ""),
      numero: dataFilialOrigemPedido.data.numero.normalize('NFD').replace(/[\u0300-\u036f]/g, ""),
      bairro: dataFilialOrigemPedido.data.bairro.normalize('NFD').replace(/[\u0300-\u036f]/g, ""),
      localidade: dataFilialOrigemPedido.data.localidade.normalize('NFD').replace(/[\u0300-\u036f]/g, ""),
      complemento: dataFilialOrigemPedido.data.complemento.normalize('NFD').replace(/[\u0300-\u036f]/g, ""),
      uf: dataFilialOrigemPedido.data.uf,
      cep: dataFilialOrigemPedido.data.cep
    }

    let scopeEnderecoCliente = {
      nome_completo: detalhesPedido.shipping_address.full_name.normalize('NFD').replace(/[\u0300-\u036f]/g, ""),
      logradouro: detalhesPedido.shipping_address.address1.normalize('NFD').replace(/[\u0300-\u036f]/g, ""),
      numero: detalhesPedido.shipping_address.number,
      bairro: detalhesPedido.shipping_address.address2.normalize('NFD').replace(/[\u0300-\u036f]/g, ""),
      localidade: detalhesPedido.shipping_address.city.normalize('NFD').replace(/[\u0300-\u036f]/g, ""),
      complemento: detalhesPedido.shipping_address.details.normalize('NFD').replace(/[\u0300-\u036f]/g, ""),
      uf: detalhesPedido.shipping_address.state,
      cep: detalhesPedido.shipping_address.postal_code
    }

    const dataPedido = {
      remetente: scopeFilialFaturamento,
      destinatario: detalhesPedido.tipoEntrega === "Entrega" ? scopeEnderecoCliente : scopeFilialOrigemPedido,
      pedido: { numero: detalhesPedido.number, filial: detalhesPedido.tipoEntrega === "Retirada" ? detalhesPedido.dadosOrigemPedido.filial : "" }
    };



    emitirEtiqueta(dataPedido)
      .then(response => {
        //   var filename = 'label.pdf'; // change file name for PNG images
        // fs.writeFile(filename, response.data, function(err) {
        //     if (err) {
        //         console.log(err);
        //     }
        // });
        console.log('data', response)
      })
      .catch(function (error) {
        console.log(error)
      });
  }

  const formataStatusZoop = (value) => {
    if (value === 'succeeded') {
      return "Aprovado";
    }
  }

  const validaBandeiraZoop = (string, gateway) => {
    let gatewayName = gateway === "pagarme" ? "Pagar Me" : "Zoop";

    if (string === "credit") {
      return `${gatewayName} Crédito`;
    } else if (string === "debit") {
      return `${gatewayName} Débito`;
    } else if (string === "boleto") {
      return "Boleto";
    } else if (string === "pix") {
      return `${gatewayName} Pix`;
    }

  }

  const validaCodigoAutorizacao = (data) => {

    if (data.payment_type === "pix") {
      return `P-${detalhesPedido.number}`;
    } else {
      if (data.payment_authorization) {
        return data.payment_authorization.authorization_code
      } else {
        return "Não autorizado";
      }
    }

  }



  async function FinalizarPedido(order_id) {
    try {
      const response = await axios.post('https://api-ideliv.ideliv.app/ideliv/loja/finalizarPedido', { id_pedido: order_id });

    } catch (error) {
      console.error(error);
    }
  }

  const carregaLista = () => {
    getListaPedidosByStatus2({ status1: "60774fb684e6861cb41a4730", status2: "60774fa684e6861cb41a472f", isHold: false, filialUsuario: getFilialUser() }).then(res => {
      setListaPedidos1(res.data);
    });

    getListaPedidosSeparados({ status1: "60774fb684e6861cb41a4730", status2: "60774fa684e6861cb41a472f", isHold: true, filialUsuario: getFilialUser() }).then(res => {
      setListaPedidos2(res.data);
    });

    getListaPedidosAprovados({ status: "60774fb684e6861cb41a4730", filialUsuario: getFilialUser(), isHold: true }).then(res => {
      setListaPedidos3(res.data);
    });

    getListaPedidosByStatus({ status: "6143414c85ee0369a5dfacb5", isHold: true, filialUsuario: getFilialUser() }).then(res => {
      setListaPedidos4(res.data);
    });

    getListaPedidosByStatus2({ status1: "6143434b85ee0369a5dfacba", status2: "614342eb85ee0369a5dfacb8", isHold: true, filialUsuario: getFilialUser() }).then(res => {
      setListaPedidos5(res.data);
    });

    getListaPedidosByStatus({ status: "630d0625d8c7d3d0ea112058", isHold: true, filialUsuario: getFilialUser() }).then(res => {
      setListaPedidos6(res.data);
    });


    getListaPedidosByStatus({ status: "6143432885ee0369a5dfacb9", isHold: true, filialUsuario: getFilialUser() }).then(res => {
      setListaPedidos7(res.data);
    });



  }


  useEffect(() => {

    carregaLista();

  }, []);

  const SectionHeader = ({ icon: Icon, title }) => (
    <Box sx={sectionHeaderSx}>
      <Avatar sx={{ width: 36, height: 36, bgcolor: '#e8eaf0', color: '#1a1a2e' }}>
        <Icon size={18} />
      </Avatar>
      <Typography sx={{ fontWeight: 700, fontSize: '1rem' }}>{title}</Typography>
    </Box>
  );

  const ColumnHeader = ({ icon: Icon, title, count }) => (
    <Box sx={columnHeaderSx}>
      <Icon size={16} color="#fff" />
      <Typography sx={{ color: '#fff', fontWeight: 600, fontSize: '0.85rem', textAlign: 'center', flex: 1 }}>
        {title}
      </Typography>
      {count !== undefined && (
        <Box sx={{ bgcolor: 'rgba(255,255,255,0.2)', borderRadius: 1, px: 1, py: 0.25 }}>
          <Typography sx={{ color: '#fff', fontSize: '0.75rem', fontWeight: 700 }}>{count}</Typography>
        </Box>
      )}
    </Box>
  );

  return (
    <Box sx={{ bgcolor: '#f5f5f5', minHeight: '100vh' }}>
      {/* Header */}
      <Box sx={{ bgcolor: '#fff', borderBottom: '1px solid #e5e5e5', py: 2 }}>
        <Box sx={{ maxWidth: '98%', mx: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography sx={{ fontWeight: 700, fontSize: '1.25rem', color: '#1a1a2e' }}>
            Pedidos
          </Typography>
        </Box>
      </Box>

      {/* Content */}
      <Box sx={{ maxWidth: '98%', mx: 'auto', py: 3 }}>
        <Grid container spacing={2}>
          {/* Pendentes/Conferencia */}
          <Grid item md sm xs={12}>
            <ColumnHeader icon={FiClock} title="Pendentes/Conferência" count={listaPedidos1.length} />
            <Box sx={{ mt: 2 }}>
              <Lista1 List1={listaPedidos1} />
            </Box>
          </Grid>

          {/* Pedidos Separados */}
          <Grid item md sm xs={12}>
            <ColumnHeader icon={FiPackage} title="Pedidos Separados" count={listaPedidos2.length} />
            <Box sx={{ mt: 2 }}>
              <Lista2 List2={listaPedidos2} onFinalizarPedido={FinalizarPedido} />
            </Box>
          </Grid>

          {/* Pag. Aprovados */}
          <Grid item md sm xs={12}>
            <ColumnHeader icon={FiCheckCircle} title="Pag. Aprovados" count={listaPedidos3.length} />
            <Box sx={{ mt: 2 }}>
              <Lista3 PedidosDespachados={listaPedidos3} onFinalizarPedido={FinalizarPedido} />
            </Box>
          </Grid>

          {/* Expedicao */}
          <Grid item md sm xs={12}>
            <ColumnHeader icon={FiBox} title="Expedição" count={listaPedidos4.length} />
            <Box sx={{ mt: 2 }}>
              <Lista4 PedidosDespachados={listaPedidos4} onFinalizarPedido={FinalizarPedido} />
            </Box>
          </Grid>

          {/* Retirada/Coleta */}
          <Grid item md sm xs={12}>
            <ColumnHeader icon={FiCornerDownRight} title="Retirada/Coleta" count={listaPedidos5.length} />
            <Box sx={{ mt: 2 }}>
              <Lista5 PedidosDespachados={listaPedidos5} onFinalizarPedido={FinalizarPedido} />
            </Box>
          </Grid>

          {getFilialUser() === "000122" && (
            <>
              {/* Backoffice */}
              <Grid item md sm xs={12}>
                <ColumnHeader icon={FiArchive} title="Backoffice" count={listaPedidos6.length} />
                <Box sx={{ mt: 2 }}>
                  <Lista6 PedidosDespachados={listaPedidos6} onFinalizarPedido={FinalizarPedido} />
                </Box>
              </Grid>

              {/* Enviado */}
              <Grid item md sm xs={12}>
                <ColumnHeader icon={FiSend} title="Enviado" count={listaPedidos7.length} />
                <Box sx={{ mt: 2 }}>
                  <Lista7 PedidosDespachados={listaPedidos7} onFinalizarPedido={FinalizarPedido} />
                </Box>
              </Grid>
            </>
          )}
        </Grid>
      </Box>

      {/* Dialog de detalhes do pedido */}
      <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
        <Box sx={{ bgcolor: '#fff', borderBottom: '1px solid #e5e5e5' }}>
          <Toolbar sx={{ maxWidth: '98%', mx: 'auto' }}>
            <IconButton edge="start" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 1, flex: 1, fontWeight: 700, fontSize: '1.15rem', color: '#1a1a2e' }}>
              Pedido #{detalhesPedido.number}
            </Typography>
            <Button
              variant="contained"
              size="large"
              onClick={handleEmitirEtiqueta}
              startIcon={<FiPrinter />}
              sx={{
                bgcolor: '#1a1a2e',
                '&:hover': { bgcolor: '#16213e' },
                textTransform: 'none',
                fontWeight: 600,
                borderRadius: 1.5,
              }}
            >
              Gerar etiqueta
            </Button>
          </Toolbar>
        </Box>

        <Box sx={{ bgcolor: '#f5f5f5', minHeight: '100vh' }}>
          <Box sx={{ maxWidth: '98%', mx: 'auto', py: 3 }}>
            {detalhesPedido && (
              <Grid container spacing={3}>
                <Grid item md={9} xs={12}>
                  <Grid container spacing={3}>
                    {/* Coluna esquerda */}
                    <Grid item md={6} xs={12}>
                      <Stack spacing={2}>
                        {/* Informacoes Pessoais */}
                        <Box sx={cardSx}>
                          <SectionHeader icon={FiUser} title="Informações Pessoais" />
                          <Grid container spacing={2} sx={{ mt: 1 }}>
                            <Grid item xs={12}>
                              <Typography sx={labelSx}>nome do cliente</Typography>
                              <Typography sx={valueXlSx}>{`${detalhesPedido.first_name} ${detalhesPedido.last_name}`}</Typography>
                            </Grid>
                            <Grid item md={4} xs={6}>
                              <Typography sx={labelSx}>telefone</Typography>
                              <Typography sx={valueXlSx}>{detalhesPedido.shipping_address.phone}</Typography>
                            </Grid>
                            <Grid item md={4} xs={6}>
                              <Typography sx={labelSx}>cpf cliente</Typography>
                              <Typography sx={valueXlSx}>{detalhesPedido.cpf ? detalhesPedido.cpf : "erro"}</Typography>
                            </Grid>
                          </Grid>
                          <Grid container spacing={2} sx={{ mt: 1 }}>
                            <Grid item xs={12}>
                              <Typography sx={labelSx}>Endereço</Typography>
                              <Typography sx={valueXlSx}>{`${detalhesPedido.shipping_address.address1},  ${detalhesPedido.shipping_address.number}, ${detalhesPedido.shipping_address.address2}, (${detalhesPedido.shipping_address.details})`}</Typography>
                              <Typography sx={valueXlSx}>{`${detalhesPedido.shipping_address.postal_code} - ${detalhesPedido.shipping_address.city} / ${detalhesPedido.shipping_address.state}`}</Typography>
                            </Grid>
                          </Grid>
                        </Box>

                        {/* Informacoes de Entrega */}
                        <Box sx={cardSx}>
                          <SectionHeader icon={FiTruck} title={`Informações de ${detalhesPedido.tipoEntrega}`} />
                          <Grid container spacing={2} sx={{ mt: 1 }}>
                            <Grid item xs={12}>
                              <Typography sx={labelSx}>enviar para</Typography>
                              {detalhesPedido.tipoEntrega === 'Entrega' ? (
                                <Box>
                                  <Typography sx={valueXlSx}>{`${detalhesPedido.shipping_address.address1},  ${detalhesPedido.shipping_address.number}, ${detalhesPedido.shipping_address.address2}, (${detalhesPedido.shipping_address.details})`}</Typography>
                                  <Typography sx={valueXlSx}>{`${detalhesPedido.shipping_address.postal_code} - ${detalhesPedido.shipping_address.city} / ${detalhesPedido.shipping_address.state}`}</Typography>
                                </Box>
                              ) : (
                                <Box>
                                  <Typography sx={valueXlSx}>
                                    <strong>Loja: {dadosFilial.codigo_filial}</strong>: {dadosFilial.logradouro},  {dadosFilial.numero},  {dadosFilial.bairro}, {dadosFilial.complemento ? `${dadosFilial.complemento},`  : ""} {dadosFilial.localidade} - {dadosFilial.uf} - {dadosFilial.cep}
                                  </Typography>
                                </Box>
                              )}
                            </Grid>
                            <Grid item md xs={6}>
                              <Typography sx={labelSx}>quem vai entregar</Typography>
                              <Typography sx={valueXlSx}>{validaEntrega(detalhesPedido.shipping_method_id)}</Typography>
                            </Grid>
                            <Grid item md xs={6}>
                              <Typography sx={labelSx}>valor da entrega</Typography>
                              <Typography sx={valueXlSx}>{detalhesPedido.shipping_price}</Typography>
                            </Grid>
                          </Grid>
                        </Box>
                      </Stack>
                    </Grid>

                    {/* Coluna direita */}
                    <Grid item md={6} xs={12}>
                      <Stack spacing={2}>
                        {/* Informacoes do Pedido */}
                        <Box sx={cardSx}>
                          <SectionHeader icon={FiClipboard} title="Informações do Pedido" />
                          <Grid container spacing={2} sx={{ mt: 1, mb: 1 }}>
                            <Grid item md={4} xs={6}>
                              <Typography sx={labelSx}>filial de origem pedido</Typography>
                              <Typography sx={valueMdSx}>{detalhesPedido.items[0].filial}</Typography>
                            </Grid>
                            <Grid item md={4} xs={6}>
                              <Typography sx={labelSx}>data</Typography>
                              <Typography sx={valueMdSx}>{moment(detalhesPedido.date_created).format('DD/MM/YYYY')}</Typography>
                            </Grid>
                            <Grid item md={4} xs={6}>
                              <Typography sx={labelSx}>status do pedido</Typography>
                              <Typography sx={valueMdSx}>{validaStatus(detalhesPedido.status_id)}</Typography>
                            </Grid>
                            <Grid item md={4} xs={6}>
                              <Typography sx={labelSx}>o cliente escolheu</Typography>
                              <Typography sx={valueMdSx}>{detalhesPedido.tipoEntrega}</Typography>
                            </Grid>
                          </Grid>
                        </Box>

                        {/* Moovpay Transaction */}
                        {moopayResponse && (
                          <Box sx={cardSx}>
                            <SectionHeader icon={FiClipboard} title="Informações da Transação" />
                            <Grid container spacing={2} sx={{ mt: 1, mb: 1 }}>
                              <Grid item md={4} xs={6}>
                                <Typography sx={labelSx}>Status</Typography>
                                <Typography sx={valueMdSx}>Aprovado</Typography>
                              </Grid>
                              <Grid item md={4} xs={6}>
                                <Typography sx={labelSx}>data</Typography>
                                <Typography sx={valueMdSx}>{moment(moopayResponse.DataAutorizacao).format('DD/MM/YYYY')}</Typography>
                              </Grid>
                              <Grid item md={4} xs={6}>
                                <Typography sx={labelSx}>Código autorização</Typography>
                                <Typography sx={valueMdSx}>{moopayResponse.NumeroAutorizacao}</Typography>
                              </Grid>
                              <Grid item md={4} xs={6}>
                                <Typography sx={labelSx}>NSU</Typography>
                                <Typography sx={valueMdSx}>{moopayResponse.NSU}</Typography>
                              </Grid>
                              <Grid item md={4} xs={6}>
                                <Typography sx={labelSx}>Administradora</Typography>
                                <Typography sx={valueMdSx}>Moovpay</Typography>
                              </Grid>
                              <Grid item md={4} xs={6}>
                                <Typography sx={labelSx}>Parcelas</Typography>
                                <Typography sx={valueMdSx}>{moopayResponse.QuantidadeParcelas}</Typography>
                              </Grid>
                              <Grid item xs={12}>
                                <Typography sx={labelSx}>Desc</Typography>
                                <Typography sx={valueMdSx}>{moopayResponse.ComprovantePdv}</Typography>
                              </Grid>
                            </Grid>
                          </Box>
                        )}

                        {/* Zoop Transaction */}
                        {detalhesPedido.responseZoop && (
                          <Box sx={cardSx}>
                            <SectionHeader icon={FiClipboard} title="Informações da Transação" />
                            <Grid container spacing={2} sx={{ mt: 1, mb: 1 }}>
                              <Grid item md={4} xs={6}>
                                <Typography sx={labelSx}>Status</Typography>
                                <Typography sx={valueMdSx}>{formataStatusZoop(detalhesPedido.responseZoop.status)}</Typography>
                              </Grid>
                              <Grid item md={4} xs={6}>
                                <Typography sx={labelSx}>data</Typography>
                                <Typography sx={valueMdSx}>{moment(detalhesPedido.responseZoop.created_at).format('DD/MM/YYYY')}</Typography>
                              </Grid>
                              <Grid item md={4} xs={6}>
                                <Typography sx={labelSx}>Código autorização</Typography>
                                <Typography sx={valueMdSx}>{validaCodigoAutorizacao(detalhesPedido.responseZoop)}</Typography>
                              </Grid>
                              <Grid item md={3} xs={6}>
                                <Typography sx={labelSx}>Tipo Pagamento</Typography>
                                <Typography sx={valueMdSx}>{validaTipoPagamento(detalhesPedido.responseZoop.payment_type)}</Typography>
                              </Grid>
                              <Grid item md={3} xs={6}>
                                <Typography sx={labelSx}>Administradora</Typography>
                                <Typography sx={valueMdSx}>{validaBandeiraZoop(detalhesPedido.responseZoop.payment_type, detalhesPedido.responseZoop.point_of_sale?.gateway)}</Typography>
                              </Grid>
                              <Grid item md={3} xs={6}>
                                <Typography sx={labelSx}>Parcelas</Typography>
                                <Typography sx={valueMdSx}>{validaParcelasPedido(detalhesPedido.parcelas, detalhesPedido.responseZoop, detalhesPedido.responseZoop.point_of_sale?.gateway)}</Typography>
                              </Grid>
                              <Grid item md={3} xs={6}>
                                <Typography sx={labelSx}>Bandeira</Typography>
                                <Typography sx={valueMdSx}>{detalhesPedido.responseZoop?.payment_method?.card_brand}</Typography>
                              </Grid>
                            </Grid>
                          </Box>
                        )}
                      </Stack>
                    </Grid>
                  </Grid>
                </Grid>

                {/* Carrinho / Resumo */}
                <Grid item md={3} xs={12}>
                  <Box sx={cardSx}>
                    <CartPedidos cartItems={detalhesPedido.items} />
                    <Box sx={{ mt: 2.5 }}>
                      <Stack direction="row" justifyContent="space-between">
                        <Typography sx={{ color: '#666', fontSize: '0.875rem' }}>Subtotal</Typography>
                        <Typography sx={{ color: '#666', fontSize: '0.875rem' }}>
                          R$ {(detalhesPedido.items).reduce((acc, { price, quantity }) => {
                            let qty = quantity;
                            let item = parseFloat(price).toFixed(2) * 0.9
                            let accumulator = parseFloat(acc).toFixed(2)
                            let res = parseFloat(item) * qty + parseFloat(accumulator)
                            return parseFloat(res).toFixed(2)
                          }, 0)}
                        </Typography>
                      </Stack>
                      <Stack direction="row" justifyContent="space-between" sx={{ mt: 0.5 }}>
                        <Typography sx={{ color: '#666', fontSize: '0.875rem' }}>Frete</Typography>
                        <Typography sx={{ color: '#666', fontSize: '0.875rem' }}>
                          <Typography component="span" sx={{ fontSize: 10 }}>R${detalhesPedido.subtotal}</Typography>
                          {detalhesPedido.shipping_price}
                        </Typography>
                      </Stack>
                      <Divider sx={{ mt: 2, mb: 2 }} />
                      <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <Typography sx={{ fontWeight: 600, color: '#333' }}>Total Geral:</Typography>
                        <Typography sx={{ fontWeight: 700, color: '#1a1a2e', fontSize: '1.05rem' }}>
                          R$ {(detalhesPedido.items).reduce((acc, { price, quantity }) => {
                            let qty = quantity;
                            let item = parseFloat(price).toFixed(2) * 0.9
                            let accumulator = parseFloat(acc).toFixed(2)
                            let res = parseFloat(item) * qty + parseFloat(accumulator)
                            return parseFloat(res).toFixed(2)
                          }, + detalhesPedido.shipping_price)}
                        </Typography>
                      </Stack>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            )}
          </Box>
        </Box>
      </Dialog>
    </Box>
  )
}
export default withRouter(PedidosPage)
